module.exports = __webpack_public_path__ + "static/synnex-logo-06c6ad8d9543da2baed535528aef6ee5.jpeg";